import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './config/amplify';
import App from './App';
import { initMonitoring } from './monitoring';

// Client error + Core Web Vitals monitoring (no-op unless REACT_APP_SENTRY_DSN is set).
initMonitoring();

const rootElement = document.getElementById('root') as HTMLElement;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The pre-rendered marketing shell exists for crawlers and no-JS visitors and
// intentionally differs from the React tree, so hydration would always mismatch
// (React errors #418/#423). Clear it and do a clean client render instead.
if (rootElement.hasChildNodes()) {
  rootElement.innerHTML = '';
}
createRoot(rootElement).render(app);
